import React from 'react';
const stats = [{
  num: '+120',
  label: 'Ready Sessions'
}, {
  num: '2,500+',
  label: 'Satisfied Coaches'
}, {
  num: '3,500+',
  label: 'Hours Saved'
}, {
  num: '99%',
  label: 'Recommendation Rate'
}];
export function TrustBar() {
  return <section className="w-full bg-bg-alt py-8 sm:py-12 border-y border-border-light px-4" data-id="element-190">
      <div className="max-w-5xl mx-auto" data-id="element-191">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-y-8 divide-x-0 md:divide-x divide-border-light" data-id="element-192">
          {stats.map((stat, i) => <div key={i} className="text-center px-4 flex flex-col items-center justify-center" data-id="element-193">
              <div className="text-text-main font-serif font-black text-3xl sm:text-4xl leading-none mb-2" data-id="element-194">
                {stat.num}
              </div>
              <p className="text-text-sec text-xs sm:text-sm font-medium uppercase tracking-wider" data-id="element-195">
                {stat.label}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}